import { CompareContentItem } from "../../types";
import { CHANGE_ROW_TINT } from "../../utils/changeStatus";
import { ChangeStatusLabel } from "../ChangeStatusLabel/ChangeStatusLabel";
import {
  AccentBar,
  Duration,
  Position,
  Row,
  StatusSlot,
  Subtitle,
  Thumbnail,
  Title,
  TitleBlock,
} from "./styles";

export interface CompareRowProps {
  item: CompareContentItem;
  /** Column identity, keeps test ids unique when an item appears on both sides. */
  sideKey: string;
}

export const CompareRow = ({ item, sideKey }: CompareRowProps) => {
  const { changeType } = item;
  const tint = changeType ? CHANGE_ROW_TINT[changeType] : null;
  const isRemoved = changeType === "removed";
  const rowTestId = `compare-${sideKey}-row-${item.id}`;

  return (
    <Row data-testid={rowTestId} $background={tint?.background}>
      {tint && <AccentBar $color={tint.bar} />}
      <Position>{item.position}</Position>
      <Thumbnail>
        {item.thumbnailUrl && <img src={item.thumbnailUrl} alt="" />}
      </Thumbnail>
      <TitleBlock>
        <Title data-testid={`${rowTestId}-title`} $muted={isRemoved}>
          {item.title}
        </Title>
        {item.subtitle && <Subtitle>{item.subtitle}</Subtitle>}
      </TitleBlock>
      {item.durationLabel && <Duration>{item.durationLabel}</Duration>}
      <StatusSlot>
        {changeType && (
          <ChangeStatusLabel changeType={changeType} idSuffix={item.id} />
        )}
      </StatusSlot>
    </Row>
  );
};
